import { useSearchResults } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<{
	isLoading: boolean;
}>;

export function useMobileFilters(): Result {
	const results = useSearchResults();

	return {
		data: {
			isLoading: results.isInitialLoad,
		},
	};
}
